import { styled } from '@mui/material';

import { LabelChip, LabelChipProps, tokens } from '@cast/design-system';
import {
  NodeResourceOffering,
  NodeResourceOfferingWithSoleTenancy,
} from '@cast/types';

import {
  nodeResourceOfferingLabelMap,
  SOLE_TENANT_OFFERING_COLOR,
} from 'features/cluster/nodes/constants/resource-offering';

export type ResourceOfferingChipProps = LabelChipProps & {
  resourceOffering: NodeResourceOfferingWithSoleTenancy;
};

type OwnerState = {
  resourceOffering: ResourceOfferingChipProps['resourceOffering'];
};

const LabelChipBase = styled(LabelChip, {
  target: 'ResourceOfferingChip-root',
  shouldForwardProp: (prop) => prop !== 'ownerState',
})<
  LabelChipProps & {
    ownerState?: OwnerState;
  }
>(({ ownerState }) => {
  return [
    { color: tokens.theme.fg.status.onNeutralSubtle },
    ownerState?.resourceOffering === NodeResourceOffering.ON_DEMAND && {
      backgroundColor: tokens.theme.bg.status.infoSubtle,
      color: tokens.theme.fg.status.onInfoSubtle,
    },
    ownerState?.resourceOffering === NodeResourceOffering.FALLBACK && {
      backgroundColor: tokens.theme.bg.status.warningSubtle,
      color: tokens.theme.fg.status.onWarningSubtle,
    },
    ownerState?.resourceOffering === NodeResourceOffering.SPOT && {
      backgroundColor: tokens.theme.bg.status.neutralSubtle,
      color: tokens.theme.fg.status.onNeutralSubtle,
    },
    ownerState?.resourceOffering === 'sole-tenant' && {
      backgroundColor: SOLE_TENANT_OFFERING_COLOR,
      color: tokens.theme.fg.categorical.onBlueStrong,
    },
  ];
});

export const ResourceOfferingChip = ({
  resourceOffering,
  size = 'sm',
  ...props
}: ResourceOfferingChipProps) => {
  return (
    <LabelChipBase ownerState={{ resourceOffering }} size={size} {...props}>
      {nodeResourceOfferingLabelMap[resourceOffering]}
    </LabelChipBase>
  );
};
